const footerColumns = [
  {
    title: "页面分区",
    links: [
      { label: "作品简介", href: "#intro" },
      { label: "观看入口", href: "#access" },
      { label: "资源导航", href: "#resources" },
      { label: "无删减说明", href: "#uncut" },
    ],
  },
  {
    title: "深入内容",
    links: [
      { label: "观看指引", href: "#guide" },
      { label: "角色一览", href: "#characters" },
      { label: "剧情看点", href: "#timeline" },
      { label: "常见问题", href: "#faq" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 px-4 pb-8 pt-14 md:px-8">
      <div className="mx-auto w-full max-w-6xl">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2 font-heading text-lg font-bold text-background-50">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-book-marked-line text-lg"></i>
              </span>
              风流女管家
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100">
              围绕「风流女管家」的资源入口导航页，集中整理在线观看、无删减版、小说原著与漫画目录，帮你在同一页里完成查找与选择。
            </p>
            <ul className="mt-4 flex flex-wrap gap-2">
              {["全集在线观看", "无删减版", "小说原著", "漫画目录"].map((tag) => (
                <li
                  key={tag}
                  className="rounded-full border border-primary-300/50 px-3 py-1 font-label text-xs text-primary-100"
                >
                  {tag}
                </li>
              ))}
            </ul>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-bold text-background-50">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="font-label text-sm text-primary-100 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-primary-700/60 pt-6 sm:flex-row sm:items-center">
          <p className="font-label text-xs text-primary-200">
            本站为内容导航与说明页面，仅整理入口信息，不提供资源本身。
          </p>
          <p className="font-label text-xs text-primary-200">
            风流女管家 · 资源导航站
          </p>
        </div>
      </div>
    </footer>
  );
}